export const UNITS = [
  'lbs', 'oz', 'kg', 'g',
  'gallon', 'quart', 'pint', 'liter', 'ml', 'fl oz', 'cup', 'tbsp', 'tsp',
  'count', 'dozen', 'bunch',
  'can', 'jar', 'bottle', 'box', 'bag', 'package', 'container', 'pouch',
  'loaf', 'stick', 'slice', 'clove',
];

export const CATEGORIES = [
  'Protein', 'Dairy', 'Grains', 'Vegetables', 'Fruits', 'Baking',
  'Oils', 'Seasonings', 'Condiments',
];
